<template>
    <div id="app">
        <notifications></notifications>
        <router-view/>
    </div>
</template>
<script>

    export default {
        created() {

            navigator.serviceWorker.getRegistrations().then(function (registrations) {
                for (let registration of registrations) {
                    registration.unregister()
                }
            })

            const isProd = 'production' === process.env.NODE_ENV;
            const apiUrl = isProd ? './api/public/lumen.php/' : 'http://player10-inscripcion.test:9100/';
            this.$store.dispatch('setApiUrl', apiUrl);

            if (this.$cookie.get('jwt')) {
                this.$store.dispatch('setJWT', this.$cookie.get('jwt'));
                this.$store.dispatch('setUser', this.$cookie.get('user'));
                this.$store.dispatch('setType', this.$cookie.get('type'));
                this.$store.dispatch('setSede', this.$cookie.get('sede'));
                this.$store.dispatch('setSeason', this.$cookie.get('season'));

                // Actuliazo la cookie del JWT si esta disponible
                var date = new Date;
                date.setDate(date.getDate() + 21);
                this.$cookie.set('jwt', this.$cookie.get('jwt'), {expires: date});
                this.$cookie.set('user', this.$cookie.get('user'), {expires: date});
                this.$cookie.set('admin', this.$cookie.get('admin'), {expires: date});
                this.$cookie.set('season', this.$cookie.get('season'), {expires: date});
            }
        },
        computed: {
            jwt() {
                return this.$store.getters.jwt
            }
        }
    };
</script>

<style>
    .flatpickr-input[readonly] {
        background-color: #fff !important;
    }

    strong {
        font-weight: bold !important;
    }

    @media (min-width: 576px) {
        .modal-dialog {
            max-width: 100% !important;
            margin: 1.75rem !important;
        }
    }
</style>
